<div class="datepicker-container">
  <input
    type="text"
    [ngClass]="classes()"
    [matDatepicker]="datePicker"
    [disabled]="disabled()"
    [min]="realMinDate()"
    [max]="realMaxDate()"
    [name]="name()"
    [id]="id()"
    [placeholder]="placeholder()"
    [(ngModel)]="date"
    (dateChange)="onDateChange($event)"
    (click)="datePicker.open()"
    [ariaLabel]="'Choose Date'"
  />

  <mat-datepicker-toggle [for]="datePicker" matSuffix [disableRipple]="true" data-testid="datepickerToggle"></mat-datepicker-toggle>
  <mat-datepicker
    #datePicker
    [disabled]="disabled()"
    [startView]="startView()"
    (monthSelected)="monthSelected.emit({ date: $event, datePicker })"
    (yearSelected)="yearSelected.emit({ date: $event, datePicker })"
  ></mat-datepicker>
</div>
